module.exports = __webpack_public_path__ + "static/13-cd996fde58d9503d0c8ec2c9a0983347.jpg";